"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Box = _interopRequireDefault(require("./Box"));

var _constants = require("./constants");

var _sx = _interopRequireDefault(require("./sx"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const BorderBox = (0, _styledComponents.default)(_Box.default).withConfig({
  displayName: "BorderBox",
  componentId: "oreju5-0"
})(["", ";", ";"], _constants.BORDER, _sx.default);
BorderBox.defaultProps = {
  borderWidth: '1px',
  borderStyle: 'solid',
  borderColor: 'border.primary',
  borderRadius: 2
};
var _default = BorderBox;
exports.default = _default;